// App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import MyNavbar from './components/Navbar';
import Home from './pages/Home';
import Home_id from './pages/Home_id';
import Home_cn from './pages/Home_cn';
import About from './pages/About';
import About_id from './pages/About_id';
import About_cn from './pages/About_cn';
import Products from './pages/Products';
import Products_id from './pages/Products_id';
import Products_cn from './pages/Products_cn';
import Contact from './pages/Contact';
import Contact_id from './pages/Contact_id';
import Contact_cn from './pages/Contact_cn';
import Career_id from './pages/Career_id';
import ScrollToHash from './components/ScrollToHash';
import Login from "./pages/Login";
import Add_product from "./pages/Admin_add_product";
import Dashboard from "./pages/Admin_dashboard";

import { useState, useEffect  } from "react";

function App() {
  const [loggedIn, setLoggedIn] = useState(false);

  // ✅ Load login state from localStorage
  useEffect(() => {
    const savedLogin = localStorage.getItem("loggedIn");
    if (savedLogin === "true") {
      setLoggedIn(true);
    }
  }, []);

  // ✅ Save login state to localStorage
  const handleLogin = () => {
    setLoggedIn(true);
    localStorage.setItem("loggedIn", "true");
  };

  const handleLogout = () => {
    setLoggedIn(false);
    localStorage.removeItem("loggedIn");
  };

  return (
    <Router>
      {/* ✅ Handler scroll ke anchor */}
      <ScrollToHash />

      {/* ✅ Navbar global */}
      <MyNavbar loggedIn={loggedIn} onLogout={handleLogout}/>

      {/* ✅ Route utama */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/home-id" element={<Home_id />} />
        <Route path="/home-cn" element={<Home_cn />} />
        <Route path="/about" element={<About />} />
        <Route path="/about-id" element={<About_id />} />
        <Route path="/about-cn" element={<About_cn />} />
        <Route path="/products" element={<Products />} />
        <Route path="/products-id" element={<Products_id />} />
        <Route path="/products-cn" element={<Products_cn />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/contact-id" element={<Contact_id />} />
        <Route path="/contact-cn" element={<Contact_cn />} />
        <Route path="/career-id" element={<Career_id />} />
        <Route path="/career" element={<Career_id />} />
        <Route path="/career-cn" element={<Career_id />} />
        
        {/* Admin login */}
        <Route path="/formeb-login" element={
            loggedIn ? (
              <Dashboard onLogout={handleLogout} />
            ) : (
              <Login onLogin={handleLogin} />
            )
          } />

        {/* Admin dashboard */}

        <Route
          path="/formeb-dashboard"
          element={
            loggedIn ? (
              <Dashboard onLogout={handleLogout} />
            ) : (
              <Login onLogin={handleLogin} />
            )
          }
        />

        <Route path="/formeb-dashboard/add-product" element={
            loggedIn ? (
              <Add_product onLogout={handleLogout} />
            ) : (
              <Login onLogin={handleLogin} />
            )
          } />

      </Routes>
    </Router>
  );
}

export default App;
